var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_327_22983)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#8199F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5572 20V18.6676L15.092 15.2024C15.43 14.861 15.7118 14.5578 15.9371 14.2926C16.1625 14.0275 16.3316 13.7706 16.4442 13.522C16.5569 13.2734 16.6133 13.0083 16.6133 12.7266C16.6133 12.4051 16.5404 12.13 16.3945 11.9013C16.2487 11.6693 16.0482 11.4903 15.793 11.3643C15.5378 11.2384 15.2478 11.1754 14.9229 11.1754C14.5882 11.1754 14.2949 11.245 14.043 11.3842C13.7911 11.5201 13.5955 11.714 13.4563 11.9659C13.3204 12.2178 13.2525 12.5178 13.2525 12.8658H11.4975C11.4975 12.2195 11.645 11.6577 11.94 11.1804C12.235 10.7031 12.641 10.3336 13.158 10.0717C13.6784 9.8099 14.275 9.67898 14.9478 9.67898C15.6306 9.67898 16.2305 9.80658 16.7475 10.0618C17.2646 10.317 17.6656 10.6667 17.9506 11.1108C18.239 11.5549 18.3832 12.062 18.3832 12.6321C18.3832 13.0133 18.3103 13.3878 18.1644 13.7557C18.0186 14.1236 17.7617 14.5312 17.3938 14.9787C17.0292 15.4261 16.5172 15.968 15.8576 16.6044L14.1026 18.3892V18.4588H18.5373V20H11.5572Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_327_22983",
    x: 0,
    y: 0,
    width: 30,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_327_22983"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.d8f6b2010600ff45440603e01f14fb0c.svg";
export { ForwardRef as ReactComponent };